/* globals document, window */
import React, { Fragment } from "react";
import GlobalAlert from "../common/GlobalAlert";
import ForgotPasswordForm from "./ForgotPasswordForm";

import { GlobalProvider } from "../common/GlobalContext";

type Props = {
  alerts: Array<Object>,
  compliance: Object,
  favorites: Array<number>,
  RECAPTCHA_CLIENT: string,
  RECAPTCHA_CLIENT_V2: string,
  siteUser: Object,
  theme: Object, // theme from the API/site settings, not the react-jss theme
};

const ForgotPassword = ({
  alerts,
  compliance,
  favorites,
  RECAPTCHA_CLIENT,
  RECAPTCHA_CLIENT_V2,
  siteUser,
  theme,
}: Props) => {
  return (
    <GlobalProvider
      compliance={compliance}
      favorites={favorites}
      siteUser={siteUser}
      theme={theme}
      RECAPTCHA_CLIENT={RECAPTCHA_CLIENT}
      RECAPTCHA_CLIENT_V2={RECAPTCHA_CLIENT_V2}
    >
      <Fragment>
        <GlobalAlert alerts={alerts} />
        <ForgotPasswordForm />
      </Fragment>
    </GlobalProvider>
  );
};

export default ForgotPassword;
